export default class TabletopCanvasKeyEvent {
    private _key: string;
    private _altKey: boolean;
    private _ctrlKey: boolean;
    private _shiftKey: boolean;

    public constructor(e: KeyboardEvent) {
        this._key = e.key;
        this._altKey = e.altKey;
        this._ctrlKey = e.ctrlKey;
        this._shiftKey = e.shiftKey;
    }

    public get key(): string {
        return this._key;
    }

    public get altKey(): boolean {
        return this._altKey;
    }

    public get ctrlKey(): boolean {
        return this._ctrlKey;
    }

    public get shiftKey(): boolean {
        return this._shiftKey;
    }
}
